import { render, staticRenderFns } from "./UserStock.vue?vue&type=template&id=069c9141&scoped=true&"
import script from "./UserStock.vue?vue&type=script&lang=js&"
export * from "./UserStock.vue?vue&type=script&lang=js&"
import style0 from "./UserStock.vue?vue&type=style&index=0&id=069c9141&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069c9141",
  null
  
)

export default component.exports